import React from 'react';
import { makeStyles, withStyles } from "@material-ui/core/styles"; import { useTranslation } from 'react-i18next';
import { productionOrderStates as states } from '../../../../Config/productionOrderStates'
import { scissorStates, scissorTypes } from '../../../../Config/scissorStates'
import ScissorSwitch from './ScissorSwitch';
import { machineScissorZone } from '../../../../Config/constants'
import ScissorStateComponent from '../../../Workstation/ScissorStateComponent';

export default function SelectScissorsContainer(props) {
    const classes = useStyles();
    const { t } = useTranslation(); 

    return <div className={classes.scissorContainer}>
        <div className={classes.top}> <div className={classes.topScissors}>{t("Top scissors")}</div>
            <div className={classes.scissorStatus}>
                <ScissorStateComponent size={"XS"} scissorStatus={props.upperScissorStatus}></ScissorStateComponent>
            </div>
        </div>
        <div className={classes.zones}>
            {props.zonesWithScissors.map(x => {

                let checked = false
                let disabled = true

                if (x.used) {
                    disabled = true
                }
                if (x.scissor === 0) {
                    checked = true
                }

                if (props.selectedZones.length > 0) {
                    if (props.selectedZones.find(y => y.zone === x.zone)) {
                        checked = props.selectedZones.find(y => y.zone === x.zone).scissor === 0
                        disabled = false
                    }
                }

                return (
                    <div className={classes.switchContainer}>
                        <ScissorSwitch
                            checked={checked}
                            onChange={() => props.switchScissor(x)}
                            name="multipleOrders"
                            disabled={disabled}
                        />
                    </div>
                )
            }
            )}

        </div>
        <div className={classes.bottom}>{t("Bottom scissors")}</div>
        <div className={classes.scissorStatus}>
            <ScissorStateComponent size={"XS"} scissorStatus={props.lowerScissorStatus}></ScissorStateComponent>
        </div>
    </div>
}

const useStyles = makeStyles({
    scissorContainer: {
        margin: "10px",
        paddingLeft: "5px"
    },
    zones: {
        marginTop: "10px"
    },
    top: {
        width: "100%",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
    },
    bottom: {
        width: "100%",
        color: "#020100",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center"
    },
    switchContainer: {
        width: "55px",
        height: "90px",
        float: "left",
        position: "relative",
        right: "20px",
        top: "5px"
    },
    topScissors: {
        paddingRight: "22px"
    },
    scrapButton: {
        border: "none",
        outline: "none",
        cursor: "pointer",
        fontSize: "8px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        height: "20px",
        width: "60px",
        borderRadius: "10px",
        marginTop: "5px"
    },
    scissorStatus:{
        width:"100%",
        textAlign:"center"
    }
});